import { memo } from 'react'
import { IVersionHistoryItem } from 'store/types/aiVideo'
import VersionHistoryItem from './VersionHistoryItem'

interface IVersionHistoryListProps {
  items: IVersionHistoryItem[]
}

const VersionHistoryList = ({ items }: IVersionHistoryListProps) => {
  return (
    <>
      {items.map(item => (
        <VersionHistoryItem key={item.id} item={item} />
      ))}
    </>
  )
}

export default memo(VersionHistoryList)
